// JSON-LD for the `proposal` surface (`/launchpad/[proposalId]`).
// A proposal is a market candidate awaiting community backing.

import type { ShareSurface } from '@/lib/share/events';

import { organizationId, websiteId } from './site';
import type { JsonLdBuilderContext, JsonLdPayload } from './types';

export function buildProposalJsonLd(
  _surface: Extract<ShareSurface, { kind: 'proposal' }>,
  ctx: JsonLdBuilderContext,
): JsonLdPayload {
  const name = ctx.name ?? 'Market proposal on Morfi';
  return [
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      '@id': `${ctx.pageUrl}#webpage`,
      url: ctx.pageUrl,
      name,
      ...(ctx.description !== undefined ? { description: ctx.description } : {}),
      primaryImageOfPage: { '@type': 'ImageObject', url: ctx.ogImageUrl },
      isPartOf: { '@id': websiteId() },
      publisher: { '@id': organizationId() },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'CreativeWork',
      '@id': `${ctx.pageUrl}#proposal`,
      name,
      ...(ctx.description !== undefined ? { description: ctx.description } : {}),
      url: ctx.pageUrl,
      image: ctx.ogImageUrl,
      author: { '@id': organizationId() },
      genre: 'Market proposal',
    },
  ];
}
